import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import ReportingPlugin from './plugins/ReportingPlugin';
import { productSectionPlugin } from './plugins/productSection';
import { MXRStore } from './mxr-store';
import { TrackingStore } from './tracking-store';
import { IRootState } from './mxr-store/state';

Vue.use(Vuex);

const plugins = [productSectionPlugin, ReportingPlugin];

const store: StoreOptions<IRootState> = {
    modules: {
        MXRStore,
        TrackingStore,
    },
    plugins,
};

export default new Vuex.Store(store);
